var _path, _path2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.691406 24.1601C0.691406 10.8152 11.5096 -0.00292969 24.8544 -0.00292969C38.1993 -0.00292969 49.0175 10.8152 49.0175 24.1601C49.0175 37.505 38.1993 48.3231 24.8544 48.3231C11.5096 48.3231 0.691406 37.505 0.691406 24.1601Z",
    fill: "white",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4980_31538",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 50,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.691406 24.1601C0.691406 10.8152 11.5096 -0.00292969 24.8544 -0.00292969C38.1993 -0.00292969 49.0175 10.8152 49.0175 24.1601C49.0175 37.505 38.1993 48.3231 24.8544 48.3231C11.5096 48.3231 0.691406 37.505 0.691406 24.1601Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4980_31538)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4980_31538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4898 11.3936H17.7684C14.4251 11.3936 11.7148 14.1038 11.7148 17.4471V31.1686C11.7148 34.5119 14.4251 37.2221 17.7684 37.2221H31.4898C34.8331 37.2221 37.5434 34.5119 37.5434 31.1686V17.4471C37.5434 14.1038 34.8331 11.3936 31.4898 11.3936Z",
    fill: "url(#paint0_radial_4980_31538)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4898 11.3936H17.7684C14.4251 11.3936 11.7148 14.1038 11.7148 17.4471V31.1686C11.7148 34.5119 14.4251 37.2221 17.7684 37.2221H31.4898C34.8331 37.2221 37.5434 34.5119 37.5434 31.1686V17.4471C37.5434 14.1038 34.8331 11.3936 31.4898 11.3936Z",
    fill: "url(#paint1_radial_4980_31538)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6254 14.2178C21.8853 14.2178 21.5414 14.2298 20.4652 14.2787C19.3911 14.3279 18.6579 14.498 18.0165 14.7475C17.3528 15.0051 16.7899 15.3499 16.2291 15.9109C15.6679 16.4717 15.3231 17.0346 15.0646 17.698C14.8144 18.3397 14.6442 19.0731 14.5959 20.1467C14.5478 21.223 14.5352 21.567 14.5352 24.3072C14.5352 27.0473 14.5473 27.3901 14.5961 28.4663C14.6455 29.5404 14.8155 30.2736 15.0648 30.915C15.3227 31.5787 15.6675 32.1416 16.2284 32.7024C16.7891 33.2636 17.352 33.6092 18.0152 33.8669C18.6571 34.1164 19.3904 34.2864 20.4643 34.3356C21.5406 34.3845 21.8842 34.3965 24.6241 34.3965C27.3645 34.3965 27.7073 34.3845 28.7834 34.3356C29.8576 34.2864 30.5916 34.1164 31.2335 33.8669C31.8969 33.6092 32.459 33.2636 33.0195 32.7024C33.5808 32.1416 33.9255 31.5787 34.184 30.9153C34.432 30.2736 34.6023 29.5402 34.6528 28.4665C34.7011 27.3903 34.7137 27.0473 34.7137 24.3072C34.7137 21.567 34.7011 21.2232 34.6528 20.1469C34.6023 19.0728 34.432 18.3398 34.184 17.6983C33.9255 17.0346 33.5808 16.4717 33.0195 15.9109C32.4584 15.3497 31.8971 15.0049 31.2329 14.7476C30.5897 14.498 29.8561 14.3278 28.782 14.2787C27.7058 14.2298 27.3632 14.2178 24.6222 14.2178H24.6254ZM23.7202 16.036C23.9889 16.0356 24.2887 16.036 24.6254 16.036C27.3193 16.036 27.6385 16.0456 28.7023 16.094C29.686 16.139 30.22 16.3033 30.5756 16.4415C31.0465 16.6243 31.3821 16.8429 31.7351 17.1961C32.0882 17.5493 32.3067 17.8855 32.4901 18.3564C32.6282 18.7115 32.7927 19.2455 32.8375 20.2292C32.8859 21.2928 32.8963 21.6122 32.8963 24.3048C32.8963 26.9975 32.8859 27.317 32.8375 28.3805C32.7925 29.3642 32.6282 29.8981 32.4901 30.2534C32.3072 30.7243 32.0882 31.0595 31.7351 31.4124C31.3819 31.7656 31.0467 31.9841 30.5756 32.167C30.2204 32.3057 29.686 32.4697 28.7023 32.5147C27.6387 32.563 27.3193 32.5735 24.6254 32.5735C21.9313 32.5735 21.612 32.563 20.5485 32.5147C19.5648 32.4693 19.0308 32.3049 18.6749 32.1668C18.2041 31.9839 17.8677 31.7654 17.5146 31.4122C17.1615 31.0591 16.943 30.7236 16.7596 30.2526C16.6215 29.8973 16.457 29.3634 16.4122 28.3797C16.3638 27.3161 16.3542 26.9967 16.3542 24.3023C16.3542 21.6081 16.3638 21.2903 16.4122 20.2267C16.4572 19.2429 16.6215 18.709 16.7596 18.3534C16.9426 17.8825 17.1615 17.5462 17.5147 17.1931C17.8678 16.84 18.2041 16.6213 18.675 16.4381C19.0306 16.2994 19.5648 16.1354 20.5485 16.0902C21.4792 16.0482 21.8399 16.0356 23.7202 16.0334V16.036ZM30.011 17.7112C29.3426 17.7112 28.8003 18.253 28.8003 18.9215C28.8003 19.5899 29.3426 20.1322 30.011 20.1322C30.6794 20.1322 31.2217 19.5899 31.2217 18.9215C31.2217 18.2531 30.6794 17.7108 30.011 17.7108V17.7112ZM24.6254 19.1258C21.764 19.1258 19.4441 21.4457 19.4441 24.3072C19.4441 27.1686 21.764 29.4874 24.6254 29.4874C27.4868 29.4874 29.8059 27.1686 29.8059 24.3072C29.8059 21.4458 27.4866 19.1258 24.6251 19.1258H24.6254ZM24.6254 20.944C26.4827 20.944 27.9885 22.4496 27.9885 24.3072C27.9885 26.1645 26.4827 27.6703 24.6254 27.6703C22.7679 27.6703 21.2623 26.1645 21.2623 24.3072C21.2623 22.4496 22.7679 20.944 24.6254 20.944Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4980_31538",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5756 39.2114) rotate(-90) scale(25.598 23.8082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4980_31538",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.38846 13.2541) rotate(78.681) scale(11.4425 47.1662)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4980_31538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8286,
    height: 25.8286,
    fill: "white",
    transform: "translate(11.6992 11.3936)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.73fc89662ec7294c2a9e2542cb2fee6b.svg";
export { ForwardRef as ReactComponent };